import { render, staticRenderFns } from "./ChatWhatsapp.vue?vue&type=template&id=4df9aa63&"
import script from "./ChatWhatsapp.vue?vue&type=script&lang=js&"
export * from "./ChatWhatsapp.vue?vue&type=script&lang=js&"
import style0 from "./ChatWhatsapp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports